import Base from 'layouts/Base';
import LoginTemplate from 'templates/LoginTemplate';

function Context() {
    return (
        <Base hidden>
            <LoginTemplate />
        </Base>
    );
}

export default Context;
